<template>
  <div>
    <v-breadcrumbs :items="breadcam"></v-breadcrumbs>
    <v-form
      @submit.prevent="investigationUpdate()"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-col cols="12" class="d-flex">
        <v-col cols="12" md="6">
          <v-card>
            <template>
              <v-card-title>{{ patient_info.patient_id }}</v-card-title>
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>Patient ID</td>
                      <td>{{ patient_info.patient_id }}</td>
                    </tr>
                    <tr>
                      <td>Patient Name</td>
                      <td>{{ patient_info.patient_name }}</td>
                    </tr>

                    <tr>
                      <td>DOB</td>
                      <td>{{ patient_info.patient_dob }}</td>
                    </tr>
                    <tr>
                      <td>Phone</td>
                      <td>{{ patient_info.patient_phone }}</td>
                    </tr>
                    <tr>
                      <td>Bloog Group</td>
                      <td>{{ patient_info.patient_blood_group }}</td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>{{ patient_info.patient_email }}</td>
                    </tr>
                    <tr>
                      <td>Address</td>
                      <td>{{ patient_info.patient_address }}</td>
                    </tr>
                    <tr>
                      <td>Registration Date</td>
                      <td>{{ patient_info.admission_date }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </template>
          </v-card>
        </v-col>
        <v-col md="6">
          <v-card>
            <v-card-title>{{ patient_info.invoice_id }}</v-card-title>
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Invoice ID</td>
                    <td>{{ investigation_data.invoice_id }}</td>
                  </tr>
                  <tr>
                    <td>Investigation Name</td>
                    <td>{{ investigation_data.invoice_description }}</td>
                  </tr>
                  <tr>
                    <td>Date</td>
                    <td>{{ investigation_data.date }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-col cols="12">
              <v-radio-group
                row
                v-model="investigation_data.invoice_eye_type"
                label="Eye "
              >
                <v-radio label="Left" value="Left" small></v-radio>
                <v-radio label="Right" value="Right" small></v-radio>
                <v-radio label="Both" value="Both"></v-radio>
                <v-radio label="None" value="-"></v-radio>
              </v-radio-group>

              <!-- <v-autocomplete
                :items="employeeData"
                item-text="employee.full_name"
                item-key="employee.id"
                v-model="investigation_data.incharge"
                label="Investigation Incharge"
                return-object
                outlined
                solo
              ></v-autocomplete> -->

              <v-btn :disabled="submitButton" type="submit" color="primary">
                Save Changes
              </v-btn>
            </v-col>
          </v-card>
        </v-col>
      </v-col>
      <v-card>
        <v-card-title>Investigation Report </v-card-title>
        <v-row>
          <v-col cols="12" md="3">
            <v-autocomplete
              label="Report Doctor"
              v-model="investgiation_report.report_doctor"
              item-text="dr_name"
              item-key="id"
              :items="doctors"
              return-object
              outlined
              dense
              v-on:change="reportDoctorUpdate()"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" md="3">
            <v-autocomplete
              label="Prepared by"
              v-model="investgiation_report.prepared"
              item-text="dr_name"
              item-key="id"
              :items="doctors"
              return-object
              outlined
              dense
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="2">
            <v-file-input
              label="Investigation Photography"
              outlined
              dense
            ></v-file-input>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn color="primary">Add Report</v-btn>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn color="primary">Report Print</v-btn>
          </v-col>
        </v-row>
        <v-col cols="12" md="6">
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>Report Doctor</td>
                  <td width="20%"></td>
                </tr>
                <tr>
                  <td>Report Doctor</td>
                  <td>Preparied By</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-card>
      <v-col cols="12">
        <v-card-text>Investigations (same invoice)</v-card-text>
        <v-data-table
          :headers="invHeaders"
          :items="invDesserts"
          class="elevation-1"
          dense
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
        >
          <template v-slot:item.status="{ item }">
            <v-chip :color="getColor(item.status)" dark>
              {{ item.status }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  @click="invoice_print(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  color="primary"
                  outlined
                >
                  <v-icon left> mdi-printer </v-icon>
                </v-chip>
              </template>
              <span>Invoice Print</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  @click="invoice_edit(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  color="primary"
                  outlined
                >
                  <v-icon left> mdi-pencil </v-icon>
                </v-chip>
              </template>
              <span>Invoice Edit</span>
            </v-tooltip>
          </template>

          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-form>
  </div>
</template>
<style scoped></style>
<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      valid: true,
      date: new Date().toISOString().substr(0, 10),
      investigation_data_edit_id: this.$route.params.id,
      investigation_data: [],
      investgiation_report: {
        report_doctor:1,
        prepared:null,
        report_date:null,
        image_path_1:null,
        image_path_2:null,
        image_path_3:null,
        image_path_4:null,
      },
      doctors: [],
      loadingstatus: false,
      patient_info: {
        name: "",
      },
      submitButton: false,
      rules: {
        required: [(value) => !!value || "Required."],
        nameRules: [
          (v) => !!v || "Patient Name is required",
          (v) =>
            (v && v.length <= 100) || "Name must be less than 100 characters",
        ],
      },

      headers: [
        {
          text: "ID",
          align: "start",
          sortable: true,
          value: "patient_id",
        },
        { text: "Name", value: "patient_name" },
        { text: "Phone", value: "patient_phone" },
        { text: "DOB", value: "patient_dob" },
        { text: "Age", value: "patient_age" },
        { text: "Gender", value: "patient_sex" },
        { text: "Reg. Date", value: "admission_date" },
      ],
      desserts: [],
      invHeaders: [
        { text: "Invoice ID", value: "invoice_id" },
        {
          text: "Investigation Name",
          sortable: true,
          value: "invoice_description",
        },
        { text: "Eye", value: "invoice_eye_type" },
        { text: "Incharge", value: "incharge.full_name" },
        { text: "Report Doctor", value: "report_doctor.dr_name" },
        { text: "Status", value: "status" },
        { text: "Action", value: "actions", sortable: false },
      ],
      invDesserts: [],
      employeeData: [],
      breadcam: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Patients",
          disabled: true,
          href: "patients",
        },
      ],
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize();
    this.getEmployementList();
    this.getDoctorList();
  },

  methods: {
    reportUpdate(){

    },
    initialize() {
      this.loadingstatus = true;
      atshq
        .get(
          "investigations/investigation-data/" + this.investigation_data_edit_id
        )
        .then((response) => {
          // JSON responses are automatically parsed.
          this.investigation_data = response.data.data;
          this.patient_info = response.data.patient_info;
          this.invDesserts = response.data.investigations;
          if (this.investigation_data.date != this.date) {
            this.submitButton = true;
          }
          console.log(this.investigation_data);
          this.loadingstatus = false;
        })
        .catch((e) => {
          // this.errors.push(e);
          this.$noty.error("Oops, something went wrong!");
          this.$noty.error(" " + e);
        });
    },
    getEmployementList() {
      atshq
        .get("hr/employment")
        .then((response) => {
          // JSON responses are automatically parsed.
          this.employeeData = response.data.data;
          this.loadingstatus = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    getDoctorList() {
      atshq
        .get("/doctors")
        .then((response) => {
          this.doctors = response.data.data;
        })
        .catch((e) => {
          this.errors = true;
          this.errorMessage = e;
        });
    },
    investigationUpdate() {
      atshq
        .put(
          "investigations/investigation-data/" +
            this.investigation_data_edit_id,
          {
            investigation_data: this.investigation_data,
            // incharge: this.investigation_data.incharge,
            report_doctor: this.investigation_data.report_doctor.id,
          }
        )
        .then((response) => {
          // JSON responses are automatically parsed.
          this.loadingstatus = false;
          this.$noty.success(response.data.messages);
          //   this.viewItem(response.data.data);
          window.location.reload();
        })
        .catch((e) => {
          // this.errors.push(e);
          this.$noty.error("Oops, something went wrong!");
          this.$noty.error(" " + e);
        });
    },
    getColor(status) {
      if (status == "void") return "red";
      else return "green";
    },
    invoice_print(item) {
      window.open(
        this.returnUrl + "printdoc/invoice/" + item.invoice_id + "/1"
      );
    },
    invoice_edit(item) {
      window.location.href = "/investigations/edit/" + item.id;
    },
  },
};
</script>